import { render } from "./CldrOrgAndUser.vue?vue&type=template&id=32e46940"
import script from "./CldrOrgAndUser.vue?vue&type=script&lang=js"
export * from "./CldrOrgAndUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__